export const LEVEL = {
    10: 1,
    9: 0.9,
    8: 0.85,
    7: 0.775,
    6: 0.7,
    5: 0.625,
    4: 0.55,
    3: 0.475,
    2: 0.4,
    1: 0.325,
    0: 0.25,
};

export function getFontSize(rawSize, level) {
    return Math.round(rawSize * LEVEL[level]);
}

export function getReverseFontSize(size, level) {
    if (!size) return;
    return (size / LEVEL[level]).toFixed(4);
}

export function getLineHeight(rawSize, level) {
    return (rawSize * LEVEL[level]).toFixed(2);
}
